export default __webpack_public_path__ + "static/media/pepperoni.d173e5db.jpg";